import * as React from 'react';

import { Col, DropDown, SvgButton, color, font } from '@coursera/coursera-ui';
import { SvgChevronDown } from '@coursera/coursera-ui/svg';

import {
  ALL_LEARNERS_FILTER_LABEL,
  COMPLETERS_FILTER_LABEL,
  STAR_FILTER_LABEL,
  STAR_VALUES,
} from 'bundles/reviews/constants';
import type { ReviewRouter } from 'bundles/reviews/types/reviewTypes';

import _t from 'i18n!nls/reviews';

type Props = {
  productCompleted?: boolean;
  ratingValues?: Array<number>;
  router: ReviewRouter;
};

class ReviewsFilters extends React.Component<Props> {
  handleLearnerSelect = (productCompleted: boolean) => {
    const {
      router,
      router: {
        location: { query: activeQueryParams },
      },
    } = this.props;

    router.replace({
      pathname: router.location.pathname,
      query: { ...activeQueryParams, completers: productCompleted, page: 1 },
    });
  };

  handleStarSelect = ({ value }: { value: Array<number> }) => {
    const {
      router,
      router: {
        location: { query: activeQueryParams },
      },
    } = this.props;

    router.replace({
      pathname: router.location.pathname,
      query: { ...activeQueryParams, star: value.join(','), page: 1 },
    });
  };

  renderLearnerButton = ({ getDropDownButtonProps }: { getDropDownButtonProps: () => {} }) => {
    const { productCompleted } = this.props;
    const learnerFilterLabel = productCompleted ? COMPLETERS_FILTER_LABEL() : ALL_LEARNERS_FILTER_LABEL();

    return (
      <SvgButton
        label={learnerFilterLabel}
        type="icon"
        svgElement={<SvgChevronDown size={18} color={color.black} hoverColor={color.secondaryText} />}
        {...getDropDownButtonProps()}
        style={{
          fontSize: font.sm,
          backgroundColor: color.bgPaper,
          color: color.secondaryText,
          height: 8,
          fontWeight: 500,
        }}
        isChildrenOnRight
        htmlAttributes={{ 'data-e2e': 'reviews-learner-filter-dropdown' }}
      />
    );
  };

  renderStarButton = ({ getDropDownButtonProps }: { getDropDownButtonProps: () => {} }) => {
    const { ratingValues } = this.props;
    const starLabel =
      ratingValues && ratingValues.length === 1
        ? `${ratingValues[0]} ${ratingValues[0] === 1 ? _t('star') : _t('stars')}`
        : STAR_FILTER_LABEL();

    return (
      <SvgButton
        label={starLabel}
        type="icon"
        svgElement={<SvgChevronDown size={18} color={color.black} hoverColor={color.secondaryText} />}
        {...getDropDownButtonProps()}
        style={{
          fontSize: font.sm,
          backgroundColor: color.bgPaper,
          color: color.secondaryText,
          height: 8,
          fontWeight: 500,
        }}
        isChildrenOnRight
        htmlAttributes={{ 'data-e2e': 'reviews-star-filter-dropdown' }}
      />
    );
  };

  render() {
    return (
      <Col md={8} style={{ display: 'flex', alignItems: 'center' }}>
        <div className="m-r-1">{_t('Filter by:')}</div>
        <DropDown.ButtonMenu
          menuStyle="d-inline-block m-r-1"
          renderButton={this.renderLearnerButton}
          style={{ textAlign: 'center' }}
        >
          <DropDown.Item
            label={COMPLETERS_FILTER_LABEL()}
            onClick={() => this.handleLearnerSelect(true)}
            htmlAttributes={{ 'data-e2e': 'reviews-learner-filter-option-completers' }}
          />
          <DropDown.Item
            label={ALL_LEARNERS_FILTER_LABEL()}
            onClick={() => this.handleLearnerSelect(false)}
            htmlAttributes={{ 'data-e2e': 'reviews-learner-filter-option-all' }}
          />
        </DropDown.ButtonMenu>
        <DropDown.ButtonMenu
          menuStyle="d-inline-block"
          renderButton={this.renderStarButton}
          style={{ textAlign: 'center' }}
        >
          {STAR_VALUES.map((star) => (
            <DropDown.Item
              key={star.label}
              label={star.label}
              onClick={() => this.handleStarSelect(star)}
              htmlAttributes={{
                'data-e2e': `reviews-star-filter-option-${star.dataE2eValue}`,
              }}
            />
          ))}
        </DropDown.ButtonMenu>
      </Col>
    );
  }
}

export default ReviewsFilters;
